import { NewNames as NewNamesForm } from '@bgea-js/form-templates';
import "../../../../src/content/conocer-a-jesus/conocer-a-jesus.scss";
import conocerJesusConfirmation from "../../../../src/content/conocer-a-jesus/customConfirmation";
import * as React from 'react';
export default {
  NewNamesForm,
  conocerJesusConfirmation,
  React
};